export default __webpack_public_path__ + "static/media/Yoga-Studio.ef6704d8.webp";